import { gql } from '@apollo/client'

export const GET_FANTASY_LEAGUE_MATCH_WEEK_SCORES = gql`
  query GetFantasyLeagueMatchWeekScores($fantasyLeagueId: ID!, $matchWeekId: ID) {
    fantasyLeagueMatchWeekScores(fantasyLeagueId: $fantasyLeagueId, matchWeekId: $matchWeekId) {
      lineups {
        id
        totalScore
        fantasyLeagueMember {
          id
          teamName
          user {
            id
            picture
            fullName
            updatedAt
          }
        }
      }
      standings {
        id
        position
        totalScore
        fantasyLeagueMember {
          id
          teamName
          user {
            id
            picture
            fullName
            updatedAt
          }
        }
      }
      previousStandings {
        id
        position
        fantasyLeagueMember {
          id
        }
      }
      currentMatchWeek {
        id
        weekNumber
      }
      hasPrevious
      hasNext
      previousMatchWeekId
      nextMatchWeekId
    }
  }
`
